





import TweenLite from 'gsap/TweenLite';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';



@Component
export default class AnimatedNumber extends Vue {
    @Prop()
    num: number

    @Watch('num', { immediate: true, deep: true })
    onNumChanged(val, oldVal) {
        TweenLite.to(this.$data, 0.5, { tweenedNum: val })
    }

    tweenedNum = 0;

    get animatedNumber() {
        return this.tweenedNum.toFixed(0);
    }
}

